(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[828],{

/***/ 70260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(69075);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/esm/styles/cssUtils.js
function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length

function convertLength(baseFontSize) {
  return (length, toUnit) => {
    const fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.

    if (fromUnit === toUnit) {
      return length;
    } // Convert input length to pixels.


    let pxLength = toUnitless(length);

    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      }
    } // Convert length in pixels to the output unit


    let outputLength = pxLength;

    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }

    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty({
  size,
  grid
}) {
  const sizeBelow = size - size % grid;
  const sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid({
  lineHeight,
  pixels,
  htmlFontSize
}) {
  return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */

function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = 'rem',
  breakpoints = [600, 900, 1200],
  transform = null
}) {
  const output = {
    [cssProperty]: `${min}${unit}`
  };
  const factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(breakpoint => {
    let value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output[`@media (min-width:${breakpoint}px)`] = {
      [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
    };
  });
  return output;
}
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(42575);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(48891);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(15672);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(69222);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/esm/Skeleton/skeletonClasses.js

function getSkeletonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSkeleton', slot);
}
const skeletonClasses = (0,generateUtilityClasses/* default */.Z)('MuiSkeleton', ['root', 'text', 'rectangular', 'rounded', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);
/* harmony default export */ var Skeleton_skeletonClasses = ((/* unused pure expression or super */ null && (skeletonClasses)));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/esm/Skeleton/Skeleton.js


const _excluded = ["animation", "className", "component", "height", "style", "variant", "width"];

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;












const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return (0,composeClasses/* default */.Z)(slots, getSkeletonUtilityClass, classes);
};

const pulseKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = getUnit(theme.shape.borderRadius) || 'px';
  const radiusValue = toUnitless(theme.shape.borderRadius);
  return (0,esm_extends/* default */.Z)({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.variant === 'rounded' && {
    borderRadius: (theme.vars || theme).shape.borderRadius
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/react.forwardRef(function Skeleton(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSkeleton'
  });

  const {
    animation = 'pulse',
    className,
    component = 'span',
    height,
    style,
    variant = 'text',
    width
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: (0,esm_extends/* default */.Z)({
      width,
      height
    }, style)
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);

/***/ }),

/***/ 47333:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hub",
      function () {
        return __webpack_require__(56942);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ClientOnlyLastUpdated; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _util_html_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13514);



/**
 * Renders ‘Updated ... ago’ text. Skips rendering during SSR to avoid hydration
 * issues in statically rendered pages.
 */ var ClientOnlyLastUpdated = function(param) {
    var value = param.value;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), ssr = ref[0], setSsr = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSsr(false);
    }, []);
    if (ssr || !value) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,_util_html_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatUpdatedAt */ .C)(value)
    });
};


/***/ }),

/***/ 81008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59452);


var Spacer = function(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        sx: {
            height: function(theme) {
                return theme.spacing(height !== null && height !== void 0 ? height : 0);
            },
            width: function(theme) {
                return theme.spacing(width !== null && width !== void 0 ? width : 0);
            }
        }
    });
};


/***/ }),

/***/ 56942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ hub_page; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(59452);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(56042);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(38079);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(42761);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(70260);
// EXTERNAL MODULE: ./src/components/icons/index.ts + 20 modules
var icons = __webpack_require__(74862);
// EXTERNAL MODULE: ./src/components/last-updated.tsx
var last_updated = __webpack_require__(87220);
// EXTERNAL MODULE: ./src/components/link.tsx
var components_link = __webpack_require__(45378);
// EXTERNAL MODULE: ./src/components/spacer.tsx
var spacer = __webpack_require__(81008);
;// CONCATENATED MODULE: ./src/components/block-card.tsx








var blockWidthStyles = {
    mx: "auto",
    maxWidth: 450,
    /** @todo: set min-width when parent grid has been refactored to use custom breakpoints */ // minWidth: 288,
    width: "100%"
};
var BlockCardLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            maxWidth: 450,
            minWidth: 288,
            width: "100%",
            borderRadius: "8px",
            boxShadow: 1,
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    backgroundColor: "gray.20",
                    py: 3,
                    px: 2.75
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 186
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    p: 3,
                    backgroundColor: function(param) {
                        var palette = param.palette;
                        return palette.common.white;
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                        height: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "72%",
                        height: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                        height: 3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "72%",
                        height: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                        height: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "52%",
                        height: 16
                    })
                ]
            })
        ]
    });
};
var BlockCard = function(param) {
    var loading = param.loading, data = param.data;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCardLoading, {});
    }
    if (!data) {
        return null;
    }
    var displayName = data.displayName, description = data.description, image = data.image, author = data.author, version = data.version, lastUpdated = data.lastUpdated, blockSitePath = data.blockSitePath, icon = data.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
        "data-testid": "block-card",
        href: blockSitePath,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blockWidthStyles), {
                position: "relative",
                borderRadius: "8px",
                transition: function(param) {
                    var transitions = param.transitions;
                    return transitions.create("transform");
                },
                backgroundColor: function(param) {
                    var palette = param.palette;
                    return palette.common.white;
                },
                cursor: "pointer",
                "&::before, &::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    pointerEvents: "none",
                    borderRadius: "8px",
                    transition: function(param) {
                        var transitions = param.transitions;
                        return transitions.create("opacity");
                    }
                },
                "&::before": {
                    boxShadow: 1,
                    opacity: 1
                },
                "&::after": {
                    boxShadow: 4,
                    opacity: 0
                },
                "&:hover": {
                    "& .block-card__name": {
                        color: function(param) {
                            var palette = param.palette;
                            return palette.purple[600];
                        }
                    },
                    transform: "scale(1.02)",
                    "&::before": {
                        opacity: 0
                    },
                    "&::after": {
                        opacity: 1
                    }
                }
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        backgroundColor: function(param) {
                            var palette = param.palette;
                            return palette.gray[20];
                        },
                        py: 3,
                        px: 2.75,
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            paddingTop: "66.67%",
                            backgroundColor: function(param) {
                                var palette = param.palette;
                                return image ? "transparent" : palette.gray[80];
                            },
                            borderRadius: "4px",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            },
                            children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "img",
                                sx: {
                                    display: "block",
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "contain",
                                    borderRadius: "4px",
                                    filter: "\n                        drop-shadow(0px 2px 8px rgba(39, 50, 86, 0.04))\n                        drop-shadow(0px 2.59259px 6.44213px rgba(39, 50, 86, 0.06))\n                        drop-shadow(0px 0.5px 1px rgba(39, 50, 86, 0.10))\n                      "
                                },
                                src: image
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BlockProtocolLogoIcon */.Et, {
                                    sx: {
                                        color: function(param) {
                                            var palette = param.palette;
                                            return palette.gray[50];
                                        }
                                    }
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        p: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mb: 2,
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        mr: 1.5,
                                        width: 24,
                                        height: 24
                                    },
                                    component: "img",
                                    src: icon !== null && icon !== void 0 ? icon : undefined
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "block-card__name",
                                    fontWeight: "600",
                                    variant: "bpLargeText",
                                    children: displayName !== null && displayName !== void 0 ? displayName : undefined
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "bpSmallCopy",
                            sx: {
                                display: "block",
                                color: "gray.70"
                            },
                            children: description && (description === null || description === void 0 ? void 0 : description.length) <= 100 ? description : "".concat(description === null || description === void 0 ? void 0 : description.slice(0, 100), "...")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                            height: 3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                typography: "bpMicroCopy",
                                display: "flex",
                                flexWrap: "wrap"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "bpMicroCopy",
                                    sx: {
                                        color: function(param) {
                                            var palette = param.palette;
                                            return palette.purple[600];
                                        },
                                        mr: 1.5,
                                        mb: 1.5
                                    },
                                    children: [
                                        "@",
                                        author
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        mr: 1.5,
                                        mb: 1.5
                                    },
                                    color: "gray.60",
                                    variant: "bpMicroCopy",
                                    children: version
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "gray.60",
                                    variant: "bpMicroCopy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(last_updated/* ClientOnlyLastUpdated */.H, {
                                        value: lastUpdated
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var BlockCardComingSoon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            py: 6,
            px: 4.25,
            minHeight: 400
        }, blockWidthStyles), {
            backgroundColor: "white",
            border: function(param) {
                var palette = param.palette;
                return "2px dashed ".concat(palette.gray["30"]);
            },
            borderRadius: "8px"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "bpHeading2",
                sx: {
                    lineHeight: 1
                },
                children: "More blocks coming soon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                height: 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    typography: "bpSmallCopy",
                    color: "gray.60"
                },
                children: "We’re working on checklists, kanban boards, blockquotes, and many more..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                height: 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    typography: "bpSmallCopy",
                    color: "gray.60"
                },
                children: [
                    "You can also",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                        href: "/docs/developing-blocks",
                        sx: {
                            color: function(param) {
                                var palette = param.palette;
                                return palette.purple[600];
                            },
                            fontWeight: 700,
                            textDecoration: "underline"
                        },
                        children: "build your own blocks."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/hub.page.tsx




var HubPage = function(param) {
    var catalog = param.catalog;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Block Protocol – Hub",
                description: "The Block Protocol's registry of open-source blocks and types"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    mb: 20,
                    position: "relative",
                    backgroundImage: "url(/assets/hub-gradient.svg)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "30% 50%",
                    backgroundSize: "100% 100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        sx: {
                            px: {
                                xs: 1,
                                sm: 4
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mb: 10,
                                pt: 8,
                                width: {
                                    xs: "100%",
                                    sm: "80%",
                                    md: "65%"
                                },
                                mx: "auto",
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    mb: {
                                        xs: 2,
                                        md: 3
                                    },
                                    sx: {
                                        color: function(param) {
                                            var palette = param.palette;
                                            return palette.purple[700];
                                        },
                                        fontWeight: 700
                                    },
                                    variant: "bpSmallCaps",
                                    children: "Hub"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    mb: 3,
                                    variant: "bpHeading1",
                                    children: "Interactive, data-driven blocks to use in your projects"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    textAlign: "center",
                                    sx: {
                                        color: function(param) {
                                            var palette = param.palette;
                                            return palette.gray[70];
                                        },
                                        maxWidth: "unset"
                                    },
                                    children: "All open-source and free to use"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        sx: {
                            px: "6.5%",
                            maxWidth: {
                                md: 720,
                                lg: 1200
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            columnSpacing: {
                                xs: 0,
                                sm: 4
                            },
                            rowSpacing: 4,
                            sx: {
                                position: "relative",
                                zIndex: 2
                            },
                            container: true,
                            children: [
                                catalog ? catalog.map(function(block) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        lg: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard, {
                                            data: block
                                        })
                                    }, block.pathWithNamespace);
                                }) : Array.from(Array(6), function(_, index) {
                                    return index + 1;
                                }).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        lg: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard, {
                                            loading: true
                                        })
                                    }, key);
                                }),
                                catalog && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCardComingSoon, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var hub_page = (HubPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(47333); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);